<!--
 * @Author: wq
 * @Date: 2020-08-31 17:13:37
-->
<template>
    <div
        class="tabs"
        v-if="isQrCode"
    >
        <el-row
            type="flex"
            class="tab_row"
            justify="center"
        >
            <div
                v-for="(item, index) in tabsData"
                :key="index"
                @click="onClickTabs(item, index)"
                :class="tabActive===item.index?'router-link-active':''"
                class="btn disabledCopy cursor"
            >{{item.name}}</div>
        </el-row>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        isQrCode: {
            type: Boolean,
            default: true
        },
        tabsData: {
            type: Array,
            default: []
        },
        tabActive: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {}
    },
    components: {},
    created() { },
    computed: {},
    watch: {},
    methods: {
        // 点击tabs
        onClickTabs(item, index) {
            this.$emit('onClickTabs', item)
        },
    }
}
</script>

<style lang='less' scoped>
.tabs {
    width: 100%;
    height: 58px;
    background-color: #184BAF;
    border-bottom: 2px solid #E70012;
    .el-row--flex.is-justify-center {
        width: 1400px;
        margin: 0 auto;
    }
    .btn {
        flex: 1;
        // width: 140px;
        line-height: 58px;
        .font(18px, #ffffff, center);
        &:hover {
            opacity: 0.8;
        }
    }
    .router-link-active {
        background-color: #2D71FA;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/indexModule/indexTabs.vue